import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

interface IIconWrapperProps {
  reverse?: boolean;
}

interface IMiddleTextProps {
  length?: number;
  isInvalid?: boolean;
}

export const Wrapper = styled.div`
  padding: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const IconWrapper = styled.div<IIconWrapperProps>`
  ${({ reverse }) => reverse && `transform: rotate(180deg);`}
`;

export const ParentTitle = styled.div`
  font-size: 13px;
  line-height: 19px;
  color: ${colors.grey5};
  letter-spacing: 0.3px;
  min-height: 19px;
  text-align: center;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 28px;
  line-height: 35px;
  letter-spacing: 0.3;
  color: ${colors.grey8};
  margin: 8px 0 24px 0;
  text-align: center;
`;

export const TypeTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: ${colors.amber};
`;

export const TipWrapper = styled.div`
  padding: 32px 35px;
  width: 361px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TipText = styled.div`
  font-weight: 500;
  font-size: 23px;
  line-height: 31px;
  text-align: center;
  letter-spacing: 0.3px;
  color: ${colors.grey8};
  margin-bottom: 32px;
`;

export const ChartWrapper = styled.div`
  margin-bottom: 8px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MiddleText = styled.div<IMiddleTextProps>`
  font-weight: 500;
  font-size: ${({ length }) => (length && length > 6 ? '23px' : '28px')};
  line-height: 35px;
  color: ${({ isInvalid }) => (isInvalid ? colors.red1 : colors.grey8)};
  letter-spacing: 0.3;
  position: absolute;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  max-width: 104px;
`;
